module.exports = {"532331101":"金山镇","532331102":"仁兴镇","532331103":"碧城镇","532331104":"勤丰镇","532331105":"一平浪镇","532331106":"广通镇","532331107":"黑井镇","532331108":"土官镇","532331109":"彩云镇","532331110":"和平镇","532331111":"恐龙山镇","532331201":"中村乡","532331203":"高峰乡","532331204":"妥安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532331.json
// module id = 2623
// module chunks = 0